export default {
  created: 'KICK_CREATED',
  progress: 'KICK_IN_PROGRESS',
  redeemed: 'KICK_REDEEMED',
  expired: 'KICK_EXPIRED',
  canceled: 'KICK_CANCELLED',
}
